<template>
  <div class="lsa-agent-control" @click.stop>
    <span>LSA AI Agent</span>
    <button
      type="button"
      role="switch"
      :aria-checked="enabled ? 'true' : 'false'"
      :aria-busy="saving ? 'true' : 'false'"
      :aria-label="'LSA AI Agent: ' + (enabled ? 'ON' : 'OFF')"
      :disabled="saving || readonly"
      :title="readonly ? 'Only an account manager can change this setting.' : 'Turn automatic LSA message replies and follow-ups on or off.'"
      :class="['lsa-agent-switch', { 'is-on': enabled }]"
      @click="toggle"
    >
      <span class="lsa-agent-knob"></span>
      <span>{{ saving ? '…' : (enabled ? 'ON' : 'OFF') }}</span>
    </button>
    <span v-if="error" class="lsa-agent-error" role="alert">{{ error }}</span>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    account: { type: Object, required: true },
    readonly: { type: Boolean, default: false }
  },
  data() { return { saving: false, error: '' } },
  computed: {
    enabled() { return ![false, 0, '0'].includes(this.account.lsa_ai_enabled) }
  },
  methods: {
    async toggle() {
      if (this.saving || this.readonly) return
      this.saving = true
      this.error = ''
      try {
        const response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/lsa-agent`, {
          enabled: !this.enabled
        }, { headers: { Authorization: 'Bearer ' + this.$store.state.auth.jwt } })
        this.$set(this.account, 'lsa_ai_enabled', response.data.lsa_ai_enabled)
      } catch (error) {
        this.error = 'Could not save. Try again.'
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.lsa-agent-control { display: flex; align-items: center; justify-content: flex-end; gap: 7px; font-size: 11px; line-height: 22px; color: #475569; }
.lsa-agent-switch { display: inline-flex; align-items: center; gap: 5px; border-radius: 12px; padding: 2px 7px 2px 3px; background: #64748b; color: white; font-weight: 700; font-size: 10px; line-height: 16px; min-width: 54px; }
.lsa-agent-switch.is-on { background: #15803d; }
.lsa-agent-knob { width: 14px; height: 14px; background: white; border-radius: 50%; }
.lsa-agent-switch.is-on .lsa-agent-knob { order: 2; }
.lsa-agent-switch:disabled { cursor: default; opacity: .6; }
.lsa-agent-switch:focus-visible { outline: 2px solid #2563eb; outline-offset: 3px; }
.lsa-agent-error { color: #b91c1c; max-width: 150px; line-height: 14px; }
</style>
